import api from "./api.service";
import { GEOIP_URL } from "a_root-folder/constants";
let geoIpURL = GEOIP_URL;

export function getGeoData() {
  return api.get(geoIpURL);
}

export function setGeoIpURL(url) {
    return geoIpURL = url;
}